/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { toast } from 'react-toastify';
import './AddEditPermit.css';
import { handleGetRequest } from '../../services/GetTemplate';
import { handlePostRequest } from '../../services/PostTemplate';
import { useDispatch } from 'react-redux';
import { handlePutRequest } from '../../services/PutTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { baseURL } from '../../Config';
import { Calendar } from 'primereact/calendar';
import classNames from 'classnames';
import QRCode from 'qrcode.react';
// import { use } from 'react';

function AddEditPermitForm({ mode = 'add' }) {
    const [permitData, setPermitData] = useState(null);
    const [isEditing, setIsEditing] = useState(mode === 'edit');
    const [isViewMode, setIsViewMode] = useState(mode === 'view');
    const [imagePreview, setImagePreview] = useState(null);
    const [cnicFrontSide, setCnicFrontSide] = useState(null);
    const [cnicBackSide, setCnicBackSide] = useState(null);
    const [vehicleRegistration, setVehicleRegistration] = useState(null);
    const [fitnessCertificate, setFitnessCertificate] = useState(null);
    const [token, setToken] = useState(null);
    const [affidavit, setAffidavit] = useState(null);
    const [applicantTypes, setApplicantTypes] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [routeNumberr, setRouteNumber] = useState([]);
    const [model, setModel] = useState([]);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState(null);
    const [cnicFrontPreview, setCnicFrontPreview] = useState(null);
    const [cnicBackPreview, setCnicBackPreview] = useState(null);
    const [fitnessCertificatePreview, setFitnessCertificatePreview] = useState(null);
    const [vehicleRegistrationPreview, setVehicleRegistrationPreview] = useState(null);
    const [tokenPreview, setTokenPreview] = useState(null);
    const [affidavitPreview, setAffidavitPreview] = useState(null);
    const [imageVisible, setImageVisible] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [imageName, setImageName] = useState(null);
    const [isLocalFile, setIsLocalFile] = useState(false);
    const [isCFXValid, setIsCFXValid] = useState(true);
    const [cfxErrorMessage, setCFXErrorMessage] = useState('');
    const [mapFields, setMappedFields] = useState(false);
    const [qrCodeValue, setQrCodeValue] = useState();
    const [qrDialogVisible, setQrDialogVisible] = useState(false);
    const [canCheckFitness, setCanCheckFitness] = useState(false);
    const [permitId, setPermitId] = useState(null);


    const fileInputRef = useRef(null);

    const dispatch = useDispatch();

    const { id } = useParams();

    const navigate = useNavigate();

    const roleName = localStorage.getItem('roleName');

    // Function to get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formik = useFormik({
        initialValues: {
            paymentMethod: '',
            phoneNumber: permitData?.phoneNumber || '',
            applicantName: permitData?.applicantName || '',
            applicantType: permitData?.applicantType || '',
            applicantCNIC: permitData?.applicantCNIC || '',
            applicantAddress: permitData?.applicantAddress || '',
            vehicleType: permitData?.vehicleType || '',
            RouteNumber: permitData?.RouteNumber || '',
            registrationNo: permitData?.registrationNo || '',
            engineNo: permitData?.engineNo || '',
            chassisNo: permitData?.chassisNo || '',
            model: permitData?.model || '',
            maker: permitData?.maker || '',
            FitnessCFX: permitData?.FitnessCFX || '',
            date: permitData?.date || getTodayDate(),
            cnicFrontSide: null,
            cnicFrontSideName: '',
            cnicBackSide: null,
            cnicBackSideName: '',
            vehicleRegistration: null,
            vehicleRegistrationName: '',
            fitnessCertificate: null,
            fitnessCertificateName: '',
            token: null,
            tokenName: '',
            affidavit: null,
            affidavitName: '',
            permitFee: permitData?.permitFee || 0,
            permitFine: permitData?.permitFine || 0,
            totalPermitFee: permitData?.totalPermitFee || 0
        },
        validate: (data) => {
            let errors = {};
            if (!data.phoneNumber) {
                errors.phoneNumber = 'Phone number is required';
            } else if (!/^[0-9]+$/.test(data.phoneNumber)) {
                errors.phoneNumber = 'Phone number must contain only numbers';
            } else if (!/^[0-9]{11}$/.test(data.phoneNumber)) {
                errors.phoneNumber = 'Phone number must be 11 digits';
            }

            if (!data.applicantName) {
                errors.applicantName = 'Applicant Name is required';
            } else if (!/^[a-zA-Z\s]+$/.test(data.applicantName)) {
                errors.applicantName = 'Name can only contain letters';
            }

            if (!data.applicantType) {
                errors.applicantType = 'Applicant Type is required';
            }

            if (!data.applicantCNIC) {
                errors.applicantCNIC = 'CNIC is required';
            } else {
                // Check if CNIC format is valid (with or without dashes)
                const cnicWithoutDashes = data.applicantCNIC.replace(/-/g, '');
                if (!/^\d{13}$/.test(cnicWithoutDashes)) {
                    errors.applicantCNIC = 'CNIC must be 13 digits';
                }
            }
            

            if (!data.applicantAddress) {
                errors.applicantAddress = 'Address is required';
            }

            if (!data.vehicleType) {
                errors.vehicleType = 'Vehicle Category is required';
            }
            if (!data.RouteNumber) {
                errors.RouteNumber = 'Route Number is required';
            }

            if (!data.registrationNo) {
                errors.registrationNo = 'Registration No. is required';
            } else if (!/^[a-zA-Z0-9-]+$/.test(data.registrationNo)) {
                errors.registrationNo = 'Registration No. can only contain letters, numbers, and hyphens';
            }
            if (!data.FitnessCFX) {
                errors.FitnessCFX = 'Fitness Certificate is required';
            }

            if (!data.engineNo) {
                errors.engineNo = 'Engine No. is required';
            } 
            // else if (!/^[a-zA-Z0-9]+$/.test(data.engineNo)) {
            //     errors.engineNo = 'Engine No. cannot contain special characters';
            // }

            if (!data.chassisNo) {
                errors.chassisNo = 'Chassis No. is required';
            } 
            // else if (!/^[a-zA-Z0-9]+$/.test(data.chassisNo)) {
            //     errors.chassisNo = 'Chassis No. cannot contain special characters';
            // }

            if (!data.model) {
                errors.model = 'Model is required';
            }

            if (!data.maker) {
                errors.maker = 'Maker is required';
            }

            if (data.permitFee === undefined || data.permitFee === '') {
                errors.permitFee = 'Permit Fee is required';
            } else if (isNaN(data.permitFee)) {
                errors.permitFee = 'Permit Fee must be a number';
            }

            if (data.permitFine === undefined || data.permitFine === '') {
                errors.permitFine = 'Permit Fine is required';
            } else if (isNaN(data.permitFine)) {
                errors.permitFine = 'Permit Fine must be a number';
            }

            if (data.totalPermitFee === undefined || data.totalPermitFee === '') {
                errors.totalPermitFee = 'Total Permit Fee is required';
            } else if (isNaN(data.totalPermitFee)) {
                errors.totalPermitFee = 'Total Permit Fee must be a number';
            }

            if (!data.cnicFrontSide) {
                errors.cnicFrontSide = 'CNIC Front Side is required';
            }

            if (!data.cnicBackSide) {
                errors.cnicBackSide = 'CNIC Back Side is required';
            }

            if (!data.vehicleRegistration) {
                errors.vehicleRegistration = 'Vehicle Registration Book is required';
            }

            if (!data.fitnessCertificate) {
                errors.fitnessCertificate = 'Fitness Certificate is required';
            }

            // if (!data.token) {
            //     errors.token = 'Token is required';
            // }

            if (!data.affidavit) {
                errors.affidavit = 'Affidavit is required';
            }

            if (!data.date) {
                errors.date = 'Date is required';
            }
            if (!data.paymentMethod) {
                errors.paymentMethod = 'Payment Method is required';
            }

            return errors;
        },
        onSubmit: async (data) => {
            try {
                if (!formik.isValid) {
                    return;
                }
                // Create FormData object
                const formData = new FormData();

                if (isEditing && permitId) {
                formData.append('Id', permitId);
            }
                formData.append('Name', data.applicantName);
                formData.append('ApplicantType', data.applicantType);
                formData.append('MobileNumber', data.phoneNumber);
                formData.append('CNIC', data.applicantCNIC.replace(/-/g, ''));
                formData.append('Address', data.applicantAddress);
                formData.append('VehicleType', data.vehicleType);
                formData.append('RouteNumber', data.RouteNumber);
                formData.append('RegisterationNumber', data.registrationNo);
                formData.append('EngineNumber', data.engineNo);
                formData.append('ChassisNumber', data.chassisNo);
                formData.append('Model', data.model);
                formData.append('Maker', data.maker);
                formData.append('FitnessCFX', String(data.FitnessCFX));
                formData.append('RegisterationFee', Number(data.permitFee));
                formData.append('FineAmount', Number(data.permitFine));
                formData.append('TotalAmount', Number(data.permitFee) + Number(data.permitFine));
                formData.append('RegistrationDate', data.date);

                // Append files - only if new files are selected in edit mode
                if (cnicFrontSide) formData.append('IdCard', cnicFrontSide);
                if (cnicBackSide) formData.append('IdCardBack', cnicBackSide);
                if (vehicleRegistration) formData.append('RegistrationBook', vehicleRegistration);
                if (fitnessCertificate) formData.append('FitnessCertificate', fitnessCertificate);
                if (token) formData.append('Token', token);
                if (affidavit) formData.append('Affidavit', affidavit);
                

                let response;
            
            if (isEditing) {
                response = await dispatch(handlePutRequest(formData, '/api/permit', true, false));
                if (response?.success === true) {
                    toast.success(response?.message || 'Permit updated successfully');
                    navigate('/permit-requests');
                }
                if (response?.success === false) {
                    toast.error(response?.message || 'Failed to update permit');
                }
            } else {
                response = await dispatch(handlePostRequest(formData, '/api/permit', true, false));
                if (response?.success === true) {
                    toast.success(response?.message || 'Permit request submitted successfully');
                    
                    if (formik.values.paymentMethod === '0') {
                        const responseId = response?.data?.requestId;
                        const qrResponse = await handleGetRequest(`/api/permit/DQR/${responseId}`);
                        if (qrResponse?.success === true) {
                            setQrCodeValue(qrResponse?.data);
                            setQrDialogVisible(true);
                        }
                    }
                    navigate('/permit-requests');
                }
                if (response?.success === false) {
                    toast.error(response?.message || 'Failed to submit permit request');
                }}
            } catch (error) {
                console.error('Error:', error);
            }
        }
    });

    const handleImageClick = () => {
        fileInputRef.current?.click();
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            formik.setFieldValue('photo', file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleFileChange = (event, fieldName) => {
    const file = event.target.files[0];
    if (file) {
        if (!file.type.startsWith('image/')) {
            toast.error(`Only image files are allowed for ${fieldName.replace(/([A-Z])/g, ' $1').trim()}`);
            event.target.value = '';
            return;
        }
        
        const maxSize = 5 * 1024 * 1024; 
        if (file.size > maxSize) {
            toast.error(`File size must not exceed 5MB`);
            event.target.value = '';
            return;
        }

        formik.setFieldValue(fieldName, file);
        formik.setFieldValue(fieldName + 'Name', file.name);

        formik.setFieldTouched(fieldName, true, false);

        const newErrors = { ...formik.errors };
        delete newErrors[fieldName];
        formik.setErrors(newErrors);

        const previewUrl = URL.createObjectURL(file);

        switch (fieldName) {
            case 'cnicFrontSide':
                setCnicFrontSide(file);
                setCnicFrontPreview(previewUrl);
                break;
            case 'cnicBackSide':
                setCnicBackSide(file);
                setCnicBackPreview(previewUrl);
                break;
            case 'vehicleRegistration':
                setVehicleRegistration(file);
                setVehicleRegistrationPreview(previewUrl);
                break;
            case 'fitnessCertificate':
                setFitnessCertificate(file);
                setFitnessCertificatePreview(previewUrl);
                break;
            case 'token':
                setToken(file);
                setTokenPreview(previewUrl);
                break;
            case 'affidavit':
                setAffidavit(file);
                setAffidavitPreview(previewUrl);
                break;
            default:
                break;
        }
    }
};

    const getRouteNumber = async () => {
        const response = await handleGetRequest('/api/dropdown/routes', false, false);
        if (response?.success) {
            setRouteNumber(response.data || []);
        } else {
            setError('Failed to fetch Route Number');
        }
    };
    useEffect(() => {
        getRouteNumber();
    }, []);
    
    useEffect(() => {
        if (formik.touched.registrationNo || formik.touched.FitnessCFX) {
            checkFieldsForFitnessCheck();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.registrationNo, formik.values.FitnessCFX]);

    const getApplicantType = async () => {
        const response = await handleGetRequest('/api/dropdown/applicants', false, false);
        if (response?.success) {
            setApplicantTypes(response.data);
        } else {
            setError('Failed to fetch applicant types');
        }
    };
    const getVehicleType = async () => {
        const response = await handleGetRequest('/api/permit/fee', false, false);
        if (response?.success) {
            setVehicleTypes(response.data || []);
        } else {
            setError('Failed to fetch Vehicle Categories');
        }
    };
    useEffect(() => {
        getApplicantType();
        getVehicleType();
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 15 }, (_, i) => currentYear - i);
        setModel(years);
    }, []);
    useEffect(() => {
        if (id && routeNumberr.length > 0) {
            fetchPermitData();
        }
    }, [id, routeNumberr]);
    useEffect(() => {
        return () => {
            if (cnicFrontPreview) URL.revokeObjectURL(cnicFrontPreview);
            if (cnicBackPreview) URL.revokeObjectURL(cnicBackPreview);
            if (vehicleRegistrationPreview) URL.revokeObjectURL(vehicleRegistrationPreview);
            if (fitnessCertificatePreview) URL.revokeObjectURL(fitnessCertificatePreview);
            if (tokenPreview) URL.revokeObjectURL(tokenPreview);
            if (affidavitPreview) URL.revokeObjectURL(affidavitPreview);
        };
    }, []);
    useEffect(() => {
        if (formik.values.vehicleType) {
            const vehicleType = vehicleTypes.find((type) => type.id === formik.values.vehicleType);
            if (vehicleType) {
                formik.setFieldValue('permitFee', vehicleType.registrationFee);
                formik.setFieldValue('totalPermitFee', Number(vehicleType.registrationFee) + Number(vehicleType.finePerDay));
            }
        }
    }, [formik.values.vehicleType, vehicleTypes]);
    useEffect(() => {
        if (formik.values.date && formik.values.vehicleType) {
            const vehicleType = vehicleTypes.find((type) => type.id === formik.values.vehicleType);
            if (vehicleType) {
                const selectedDate = new Date(formik.values.date);
                const today = new Date();

                selectedDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);

                // Calculate difference in days
                const diffTime = Math.abs(today - selectedDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                // Apply fine if more than 15 days
                if (diffDays > 15) {
                    const fineDays = diffDays - 15; 
                    const permitFine = vehicleType.finePerDay * fineDays;
                    formik.setFieldValue('permitFine', permitFine);
                    formik.setFieldValue('totalPermitFee', Number(vehicleType.registrationFee) + Number(permitFine));
                } else {
                    formik.setFieldValue('permitFine', 0);
                    formik.setFieldValue('totalPermitFee', Number(vehicleType.registrationFee));
                }
            }
        }
    }, [formik.values.date, formik.values.vehicleType, vehicleTypes]);
    const fetchPermitData = async () => {
        try {
            const response = await handleGetRequest(`/api/permit/${id}`);
            if (response?.success) {
                const routeId = routeNumberr?.filter((item) => item?.id === Number(response?.data[0]?.routeNumber));
                setPermitData(response?.data[0]);
                setStatus(response?.data[0]?.status);
                setPermitId(response?.data[0]?.id);
                formik.setValues({
                    phoneNumber: response?.data[0]?.mobileNum,
                    applicantName: response.data[0].name,
                    applicantType: response.data[0].applicantTypeId,
                    applicantCNIC: response.data[0].cnic.length === 13 
                        ? `${response.data[0].cnic.substring(0, 5)}-${response.data[0].cnic.substring(5, 12)}-${response.data[0].cnic.substring(12)}`
                        : response.data[0].cnic,
                    applicantAddress: response.data[0].address,
                    vehicleType: response.data[0].vehicleType,
                    registrationNo: response.data[0].regNum,
                    engineNo: response.data[0].engineNum,
                    chassisNo: response.data[0].chassisNum,
                    model: response.data[0].model,
                    maker: response.data[0].maker,
                    vehicleRegistration: response.data[0].regBook,
                    vehicleRegistrationName: response.data[0].regBook || '',
                    fitnessCertificate: response.data[0].fitness,
                    fitnessCertificateName: response.data[0].fitness || '',
                    token: response.data[0].token,
                    tokenName: response.data[0].token || '',
                    affidavit: response.data[0].affidavit,
                    affidavitName: response.data[0].affidavit || '',
                    cnicFrontSide: response.data[0].nicFront,
                    cnicFrontSideName: response.data[0].nicFront || '',
                    cnicBackSide: response.data[0].nicBack,
                    cnicBackSideName: response.data[0].nicBack || '',
                    permitFee: response.data[0].registerationFee,
                    permitFine: response.data[0].fineAmount,
                    totalPermitFee: response.data[0].totalAmount,
                    date: response?.data[0]?.reqDate,
                    FitnessCFX: response?.data[0]?.fitnessCFX,
                    paymentMethod: response?.data[0]?.paymentMethod,
                    RouteNumber: routeId[0]?.id
                });
                
            }
        } catch (error) {
            console.error('Error fetching permit data:', error);
        } finally {
        }
    };
    // useEffect(() => {
    //     if (formik.values.FitnessCFX !== null && formik.values.FitnessCFX !== undefined && formik.values.FitnessCFX !== '') {
    //         validateCFX();
    //     }
    // }, [formik.values.FitnessCFX]);

    const handleBack = () => {
        navigate('/permit-requests');
    };
    const getFormTitle = () => {
        if (isViewMode) return 'View Permit Request';
        if (isEditing) return 'Edit Permit Request';
        return 'Add New Permit Request';
    };

    const getSubmitButtonProps = () => {
        if (isViewMode) return { label: 'Close', onClick: handleBack, disabled: false };
        const disabled = !formik.isValid || formik.isSubmitting || !isCFXValid;
        if (isEditing) return { label: 'UPDATE', type: 'submit', disabled };
        return { label: 'ADD', type: 'submit', disabled };
    };
    const handleUpdateStatus = (status) => async () => {
        const response = await dispatch(handlePutRequest([], `/api/Request/UpdateStatus?id=${id}&status=${status}`));
        if (response?.success) {
            setTimeout(() => {
                navigate('/permit-requests');
            }, 1000);
        }
    };
    const isFormFieldValid = (name) => {
        // First check if there's an actual file uploaded for file input fields
        if (name === 'cnicFrontSide' && (cnicFrontSide || formik.values.cnicFrontSideName)) {
            return false;
        } else if (name === 'cnicBackSide' && (cnicBackSide || formik.values.cnicBackSideName)) {
            return false;
        } else if (name === 'vehicleRegistration' && (vehicleRegistration || formik.values.vehicleRegistrationName)) {
            return false;
        } else if (name === 'fitnessCertificate' && (fitnessCertificate || formik.values.fitnessCertificateName)) {
            return false;
        } else if (name === 'token' && (token || formik.values.tokenName)) {
            return false;
        } else if (name === 'affidavit' && (affidavit || formik.values.affidavitName)) {
            return false;
        }

        // Default case - check if field is touched and has errors
        return !!(formik.touched[name] && formik.errors[name]);
    };
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    const showImagePreview = (url, name, isLocal = false) => {
        // Don't revoke URLs when displaying - we'll handle cleanup elsewhere
        setImageUrl(url);
        setImageName(name);
        setIsLocalFile(isLocal);
        setImageVisible(true);
    };

    // Check if both registration number and CFX number are filled
    // and update validation messages as fields change
    const checkFieldsForFitnessCheck = () => {
        const hasRegNumber = Boolean(formik.values.registrationNo);
        const hasCFXNumber = Boolean(formik.values.FitnessCFX);
        const hasBothFields = hasRegNumber && hasCFXNumber;
        
        // Update button state
        setCanCheckFitness(hasBothFields);
        
        // Update validation messages in real-time
        const cleanedErrors = {};
        
        if (!hasCFXNumber && !hasRegNumber) {
            // Both fields are missing - only show message if user has interacted with fields
            if (formik.touched.registrationNo || formik.touched.FitnessCFX) {
                setCFXErrorMessage('Both CFXNo and Registration Number are required.');
                setIsCFXValid(false);
            }
        } else if (!hasCFXNumber) {
            // Only CFX Number is missing
            setCFXErrorMessage('CFXNo is required.');
            setIsCFXValid(false);
        } else if (!hasRegNumber) {
            // Only Registration Number is missing
            cleanedErrors.registrationNo = 'Registration Number is required.';
            setCFXErrorMessage(''); 
        } else {
            // All required fields are present
            setCFXErrorMessage('');
            setIsCFXValid(true);
        }
        
        formik.setErrors({...formik.errors, ...cleanedErrors});
        
        return hasBothFields;
    };

    const validateCFX = async (e) => {
        if (e) e.preventDefault();
        
        // Initialize error tracking variables
        const cleanedErrors = {};
        let hasError = false;
        
        // Check for missing required fields - reuse the checkFieldsForFitnessCheck logic
        const isValid = checkFieldsForFitnessCheck();
        if (!isValid) {
            return; // Exit early if validation fails
        }
        
        // Update form errors
        formik.setErrors(cleanedErrors);
        
        // Handle validation errors - just return without proceeding
        if (hasError) {
            return;
        }
        
        // Prepare data for API request
        const data = {
            cfx: formik.values.FitnessCFX,
            regNo: formik.values.registrationNo
        };

        // Make API request to validate fitness certificate
        const response = await dispatch(handlePostRequest(data, '/api/fitness/validate', true, false));
        if (response?.success === true) {
            // Success case
            setMappedFields(true);
            setCFXErrorMessage('');
            setIsCFXValid(true);
            
            // Set form values from response
            formik.setFieldValue('chassisNo', response?.data?.chasisno);
            formik.setFieldValue('engineNo', response?.data?.engineNo);
            formik.setFieldValue('maker', response?.data?.maker);
            formik.setFieldValue('model', response?.data?.model);
            formik.setFieldValue('applicantName', response?.data?.applicantName);
            // Format CNIC with dashes if needed
            const cnic = response?.data?.applicantCNIC;
            if (cnic) {
                const cnicWithoutDashes = cnic.replace(/-/g, '');
                if (cnicWithoutDashes.length === 13) {
                    formik.setFieldValue('applicantCNIC', `${cnicWithoutDashes.substring(0, 5)}-${cnicWithoutDashes.substring(5, 12)}-${cnicWithoutDashes.substring(12)}`);
                } else {
                    formik.setFieldValue('applicantCNIC', cnic);
                }
            }
            formik.setFieldValue('phoneNumber', response?.data?.applicantMobile);
            // If Vehicle Category mapping is needed, uncomment and adjust the line below
            // formik.setFieldValue('vehicleType', response?.data?.typeOfVehicle && parseInt(response?.data?.typeOfVehicle));
            // Show success message
            toast.success('Fitness certificate validated successfully');
        } else {
            // Error case
            setIsCFXValid(false);
            setMappedFields(false);
            
            // Clear form values
            formik.setFieldValue('chassisNo', '');
            formik.setFieldValue('engineNo', '');
            formik.setFieldValue('maker', '');
            formik.setFieldValue('model', '');
            // formik.setFieldValue('vehicleType', '');

            // Show error message
            toast.error(response?.message || 'Invalid CFX No. or Registration No.');
        }
    };


    const paymentMethods = [
        {
            label: 'Cash Payment',
            value: '1'
        },
        {
            label: 'Online Payment',
            value: '0'
        }
    ];


    return (
        <div className="p-5 max-w-screen-xl mx-auto bg-white border-round shadow-2">
            <div className="col-12">
                <Dialog
                    header={
                        <div className="header-content">
                            <h2>{imageName}</h2>
                            <button className="close-button" onClick={() => setImageVisible(false)}>
                                <i className="pi pi-times"></i>
                            </button>
                        </div>
                    }
                    visible={imageVisible}
                    closable={false}
                    onHide={() => setImageVisible(false)}
                    className="image-dialog"
                    style={{ width: '898px', height: '722px' }}
                >
                    {imageUrl &&
                        (isLocalFile ? (
                            <img src={imageUrl} alt="Preview" style={{ width: '773.51px', height: '551.12px', objectFit: 'contain' }} />
                        ) : (
                            <img src={`${baseURL}${imageUrl}`} alt="Document" style={{ width: '773.51px', height: '551.12px', objectFit: 'contain' }} />
                        ))}
                </Dialog>

                <Dialog
                    header={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '80px' }}>
                            <h2 className="m-2" style={{ textAlign: 'center' }}>
                                Scan QR Code for online payment
                            </h2>
                            <Button icon="pi pi-times" className="p-button-text p-button-rounded p-button-danger" onClick={() => setQrDialogVisible(false)} />
                        </div>
                    }
                    visible={qrDialogVisible}
                    closable={false}
                    onHide={() => qrDialogVisible(false)}
                    className="image-dialog"
                    style={{ width: '898px', height: '722px' }}
                >
                    {qrCodeValue ? (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'center', margin: '1rem' }}>
                                <QRCode value={qrCodeValue?.qrString} size={256} />
                            </div>
                            <p style={{ textAlign: 'center' }}>
                                Use QR Code or use consumer id: <strong>{qrCodeValue?.consumerId}</strong> for payment
                            </p>
                        </>
                    ) : (
                        <p>No QR data returned.</p>
                    )}
                </Dialog>

                <div className="flex justify-content-between align-items-center mb-4">
                    <h2 className="text-xl font-semibold">{getFormTitle()}</h2>
                    <Button icon="pi pi-times" onClick={handleBack} className="p-button-rounded p-button-danger p-button-text" style={{ fontSize: '1rem' }} />
                </div>

                <form onSubmit={formik.handleSubmit}>
                    <h3 className="section-title">Vehicle Information</h3>
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="registrationNo" className={classNames({ 'p-error': isFormFieldValid('registrationNo') }, 'Label__Text')}>
                                        Vehicle Registration No. <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="registrationNo"
                                        onBlur={(e) => {
                                            formik.handleBlur(e);
                                            checkFieldsForFitnessCheck(); // Validate on blur
                                        }}
                                        name="registrationNo"
                                        value={formik.values.registrationNo || ''}
                                        placeholder="ABC-1234"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            formik.setFieldTouched('registrationNo', true, false);
                                            setTimeout(checkFieldsForFitnessCheck, 0); // Validate immediately
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldValid('registrationNo') || formik.errors.registrationNo }, 'Input__Round ')}
                                        disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('registrationNo')}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="FitnessCFX" className={classNames({ 'p-error': !isCFXValid && cfxErrorMessage }, 'Label__Text')}>
                                        CFX Number <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="FitnessCFX"
                                        name="FitnessCFX"
                                        value={formik.values.FitnessCFX || ''}
                                        placeholder="Enter Fitness CFX"
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            formik.setFieldTouched('FitnessCFX', true, false);
                                            setTimeout(checkFieldsForFitnessCheck, 0); // Validate immediately
                                        }}
                                        onBlur={(e) => {
                                            formik.handleBlur(e);
                                            checkFieldsForFitnessCheck(); // Validate on blur
                                        }}
                                        className={classNames({ 'p-invalid': !isCFXValid && cfxErrorMessage }, 'Input__Round')}
                                        disabled={isViewMode}
                                    />
                                    {cfxErrorMessage && <small className="p-error">{cfxErrorMessage}</small>}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-2">
                            <div className="p-field col-12 md:col-12">
                                <Button 
                                label="Check Fitness" 
                                onClick={(e) => validateCFX(e)}  
                                className="p-button-primary"
                                disabled={!formik.values.registrationNo || !formik.values.FitnessCFX || isViewMode}
                                style={{ 
                                    minWidth: '120px', 
                                    height: '40px', 
                                    backgroundColor: (formik.values.registrationNo && formik.values.FitnessCFX) ? '#FF556A' : '#cccccc', 
                                    border: 'none', 
                                    marginTop: '30px',
                                    cursor: (formik.values.registrationNo && formik.values.FitnessCFX) ? 'pointer' : 'not-allowed'
                                }}
                                />
                            </div>
                        </div>
                        {true && (
                            <>
                                <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="engineNo" className={classNames({ 'p-error': isFormFieldValid('engineNo') }, 'Label__Text')}>
                                                Engine No. <span className="Label__Required">*</span>
                                            </label>
                                            <InputText
                                                id="engineNo"
                                                onBlur={formik.handleBlur}
                                                name="engineNo"
                                                value={formik.values.engineNo || ''}
                                                placeholder="XXXX1232"
                                                onChange={formik.handleChange}
                                                className={classNames({ 'p-invalid': isFormFieldValid('engineNo') }, 'Input__Round ')}
                                                disabled
                                            />
                                            {/* {getFormErrorMessage('engineNo')} */}
                                        </div>
                                    </div>
                                </div>
                                <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="chassisNo" className={classNames({ 'p-error': isFormFieldValid('chassisNo') }, 'Label__Text')}>
                                                Chassis No. <span className="Label__Required">*</span>
                                            </label>
                                            <InputText
                                                id="chassisNo"
                                                onBlur={formik.handleBlur}
                                                name="chassisNo"
                                                value={formik.values.chassisNo || ''}
                                                placeholder="XXX1232"
                                                onChange={formik.handleChange}
                                                className={classNames({ 'p-invalid': isFormFieldValid('chassisNo') }, 'Input__Round ')}
                                                disabled
                                            />
                                            {/* {getFormErrorMessage('chassisNo')} */}
                                        </div>
                                    </div>
                                </div>
                                <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="model" className={classNames({ 'p-error': isFormFieldValid('model') }, 'Label__Text')}>
                                                Model <span className="Label__Required">*</span>
                                            </label>

                                            <InputText
                                                id="model"
                                                name="model"
                                                // onBlur={formik.handleBlur}
                                                value={formik.values.model || ''}
                                                placeholder="Select Model"
                                                onChange={formik.handleChange}
                                                className={classNames({ 'p-invalid': isFormFieldValid('model') }, 'Input__Round')}
                                                disabled
                                            />

                                            {getFormErrorMessage('model')}

                                            {/* Show input if 'Other' is selected */}
                                            {formik.values.model === 'Other' && (
                                                <InputText
                                                    id="otherModel"
                                                    name="otherModel"
                                                    placeholder="Enter other model"
                                                    value={formik.values.otherModel || ''}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className={classNames({ 'p-invalid': isFormFieldValid('otherModel') })}
                                                    disabled={isViewMode}
                                                />
                                            )}

                                            {/* Show error for 'otherModel' if applicable */}
                                            {formik.values.model === 'Other' && getFormErrorMessage('otherModel')}
                                        </div>
                                    </div>
                                </div>
                                <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="maker" className={classNames({ 'p-error': isFormFieldValid('maker') }, 'Label__Text')}>
                                                Maker. <span className="Label__Required">*</span>
                                            </label>
                                            <InputText
                                                id="maker"
                                                onBlur={formik.handleBlur}
                                                name="maker"
                                                value={formik.values.maker || ''}
                                                placeholder="Enter Maker"
                                                onChange={formik.handleChange}
                                                className={classNames({ 'p-invalid': isFormFieldValid('maker') }, 'Input__Round ')}
                                                disabled
                                            />
                                            {/* {getFormErrorMessage('maker')} */}
                                        </div>
                                    </div>
                                </div>
                               
                            </>
                        )}
                        {/* <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">     */}
                         <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="vehicleType" className={classNames({ 'p-error': isFormFieldValid('vehicleType') }, 'Label__Text')}>
                                                Vehicle Category <span className="Label__Required">*</span>
                                            </label>
                                            <Dropdown
                                                id="vehicleType"
                                                name="vehicleType"
                                                placeholder="Please select Vehicle Category"
                                                onBlur={formik.handleBlur}
                                                value={formik.values.vehicleType || ''}
                                                options={vehicleTypes}
                                                optionLabel="categoryName"
                                                optionValue="id"
                                                onChange={formik.handleChange}
                                                className={classNames({ 'p-invalid': isFormFieldValid('vehicleType') }, 'Dropdown__Round ')}
                                                // disabled={isViewMode}
                                            />

                                            {getFormErrorMessage('vehicleType')}
                                        </div>
                                    </div>
                                </div>

                                <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="RouteNumber" className={classNames({ 'p-error': isFormFieldValid('RouteNumber') }, 'Label__Text')}>
                                                Route Number <span className="Label__Required">*</span>
                                            </label>
                                            <Dropdown
                                                id="RouteNumber"
                                                name="RouteNumber"
                                                onBlur={formik.handleBlur}
                                                value={formik.values.RouteNumber || ''}
                                                options={routeNumberr}
                                                optionLabel="name"
                                                optionValue="id"
                                                placeholder="Select Route Number"
                                                onChange={(e) => formik.setFieldValue('RouteNumber', e.value)}
                                                className={classNames({ 'p-invalid': isFormFieldValid('RouteNumber') }, 'Dropdown__Round')}
                                                disabled={isViewMode}
                                            />

                                            {getFormErrorMessage('RouteNumber')}
                                        </div>
                                    </div>
                                </div>
                                <div className="p-fluid p-formgrid grid col-12 md:col-4">
                                    <div className="p-field col-12 md:col-12 pt-3">
                                        <div className="p-field">
                                            <label htmlFor="date" className={classNames({ 'p-error': isFormFieldValid('date') }, 'Label__Text')}>
                                                Registration Date<span className="Label__Required">*</span>
                                            </label>
                                            <InputText
                                                type="date"
                                                id="date"
                                                name="date"
                                                value={formik.values.date || ''}
                                                onBlur={formik.handleBlur}
                                                onChange={(e) => formik.setFieldValue('date', e.target.value)}
                                                placeholder="Enter date"
                                                className={classNames({ 'p-invalid': isFormFieldValid('date') }, 'Input__Round')}
                                                disabled
                                                showIcon
                                                dateFormat="yy-mm-dd"
                                            />
                                            {getFormErrorMessage('date')}
                                        </div>
                                    </div>
                                </div> 
                                </div>
                    {/* </div> */}
                    <h3 className="section-title">Contact Info</h3>
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="applicantName" className={classNames({ 'p-error': isFormFieldValid('applicantName') }, 'Label__Text')}>
                                        Applicant Name <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="applicantName"
                                        onBlur={formik.handleBlur}
                                        name="applicantName"
                                        placeholder="Enter Applicant Name"
                                        value={formik.values.applicantName || ''}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('applicantName') }, 'Input__Round ')}
                                        disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('applicantName')}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="applicantType" className={classNames({ 'p-error': isFormFieldValid('applicantType') }, 'Label__Text')}>
                                        Applicant Type <span className="Label__Required">*</span>
                                    </label>
                                    <Dropdown
                                        id="applicantType"
                                        name="applicantType"
                                        onBlur={formik.handleBlur}
                                        value={formik.values.applicantType || ''}
                                        options={applicantTypes}
                                        optionLabel="name"
                                        optionValue="id"
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('applicantType') }, 'Dropdown__Round ')}
                                        disabled={isViewMode}
                                        placeholder="Please select applicant type"
                                    />

                                    {getFormErrorMessage('applicantType')}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="phoneNumber" className={classNames({ 'p-error': isFormFieldValid('phoneNumber') }, 'Label__Text')}>
                                        Phone No. <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="phoneNumber"
                                        onBlur={formik.handleBlur}
                                        name="phoneNumber"
                                        value={formik.values.phoneNumber || ''}
                                        placeholder="03XX-XXXXXXX"
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('phoneNumber') }, 'Input__Round ')}
                                        disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('phoneNumber')}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="applicantCNIC" className={classNames({ 'p-error': isFormFieldValid('applicantCNIC') }, 'Label__Text')}>
                                        CNIC. <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="applicantCNIC"
                                        onBlur={formik.handleBlur}
                                        name="applicantCNIC"
                                        value={formik.values.applicantCNIC || ''}
                                        placeholder="XXXXX-XXXXXXX-X"
                                        onChange={(e) => {
                                            // Let Formik handle the raw value
                                            formik.handleChange(e);
                                            
                                            // Format with dashes if entered without them
                                            const value = e.target.value.replace(/-/g, '');
                                            if (value.length <= 13 && /^\d+$/.test(value)) {
                                                let formatted = value;
                                                if (value.length > 5) {
                                                    formatted = `${value.substring(0, 5)}-${value.substring(5)}`;
                                                }
                                                if (value.length > 12) {
                                                    formatted = `${formatted.substring(0, 13)}-${formatted.substring(13)}`;
                                                }
                                                formik.setFieldValue('applicantCNIC', formatted);
                                            }
                                        }}
                                        className={classNames({ 'p-invalid': isFormFieldValid('applicantCNIC') }, 'Input__Round ')}
                                        disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('applicantCNIC')}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="applicantAddress" className={classNames({ 'p-error': isFormFieldValid('applicantAddress') }, 'Label__Text')}>
                                        Applicant Address <span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        id="applicantAddress"
                                        onBlur={formik.handleBlur}
                                        name="applicantAddress"
                                        value={formik.values.applicantAddress || ''}
                                        placeholder="Hno 123, St No 4, ABC Colony, XYZ City"
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('applicantAddress') }, 'Input__Round ')}
                                        disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('applicantAddress')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 className="section-title">Documents Attached</h3>
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field ">
                                    <div className="flex justify-content-between">
                                        <label htmlFor="cnicFrontSide" className={classNames({ 'p-error': isFormFieldValid('cnicFrontSide') }, 'Label__Text')}>
                                            CNIC Front <span className="Label__Required">*</span>
                                        </label>
                                        {(cnicFrontSide || formik.values.cnicFrontSideName) && (
                                            <i
                                                className="pi pi-eye cursor-pointer"
                                                onClick={() => {
                                                    if (isViewMode) {
                                                        // For view mode (server URL)
                                                        showImagePreview(formik.values.cnicFrontSide, 'CNIC Front');
                                                    } else if (cnicFrontSide) {
                                                        // For edit/add mode with new file (local preview)
                                                        showImagePreview(cnicFrontPreview, 'CNIC Front', true);
                                                    } else if (formik.values.cnicFrontSideName) {
                                                        // For edit mode with existing file (server URL)
                                                        showImagePreview(formik.values.cnicFrontSide, 'CNIC Front');
                                                    }
                                                }}
                                            ></i>
                                        )}
                                    </div>

                                    <div className="file-input-wrapper">
                                        <InputText
                                            type="file"
                                            accept="image/*,.jpg,.jpeg,.png"
                                            id="cnicFrontSide"
                                            onBlur={formik.handleBlur}
                                            name="cnicFrontSide"
                                            onChange={(e) => {
                                                handleFileChange(e, 'cnicFrontSide');
                                            }}
                                            className={`hidden-file-input ${classNames({ 'p-invalid': isFormFieldValid('cnicFrontSide') })}`}
                                            disabled={isViewMode}
                                        />
                                        <div 
                                            className={`custom-file-input Input__Round ${classNames({ 'p-invalid': isFormFieldValid('cnicFrontSide') })}`}
                                            onClick={() => !isViewMode && document.getElementById('cnicFrontSide').click()}
                                        >
                                            <span className="file-name">
                                                {formik.values.cnicFrontSideName ? 
                                                    formik.values.cnicFrontSideName : 
                                                    (cnicFrontSide ? cnicFrontSide.name : "Choose file...")}
                                            </span>
                                            {!isViewMode && <span className="file-button">Browse</span>}
                                        </div>
                                    </div>

                                    {getFormErrorMessage('cnicFrontSide')}
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <div className="flex justify-content-between">
                                        <label htmlFor="cnicBackSide" className={classNames({ 'p-error': isFormFieldValid('cnicBackSide') }, 'Label__Text')}>
                                            CNIC Back <span className="Label__Required">*</span>
                                        </label>
                                        {(cnicBackSide || formik.values.cnicBackSideName) && (
                                            <i
                                                className="pi pi-eye cursor-pointer"
                                                onClick={() => {
                                                    if (isViewMode) {
                                                        showImagePreview(formik.values.cnicBackSide, 'CNIC Back');
                                                    } else if (cnicBackSide) {
                                                        showImagePreview(cnicBackPreview, 'CNIC Back', true);
                                                    } else if (formik.values.cnicBackSideName) {
                                                        showImagePreview(formik.values.cnicBackSide, 'CNIC Back');
                                                    }
                                                }}
                                            ></i>
                                        )}
                                    </div>
                                    <div className="file-input-wrapper">
                                        <InputText
                                            type="file"
                                            accept="image/*,.jpg,.jpeg,.png"
                                            id="cnicBackSide"
                                            onBlur={formik.handleBlur}
                                            name="cnicBackSide"
                                            onChange={(e) => {
                                                handleFileChange(e, 'cnicBackSide');
                                            }}
                                            className={`hidden-file-input ${classNames({ 'p-invalid': isFormFieldValid('cnicBackSide') })}`}
                                            disabled={isViewMode}
                                        />
                                        <div 
                                            className={`custom-file-input Input__Round ${classNames({ 'p-invalid': isFormFieldValid('cnicBackSide') })}`}
                                            onClick={() => !isViewMode && document.getElementById('cnicBackSide').click()}
                                        >
                                            <span className="file-name">
                                                {formik.values.cnicBackSideName ? 
                                                    formik.values.cnicBackSideName : 
                                                    (cnicBackSide ? cnicBackSide.name : "Choose file...")}
                                            </span>
                                            {!isViewMode && <span className="file-button">Browse</span>}
                                        </div>
                                    </div>

                                    {getFormErrorMessage('cnicBackSide')}
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <div className="flex justify-content-between">
                                        <label htmlFor="vehicleRegistration" className={classNames({ 'p-error': isFormFieldValid('vehicleRegistration') }, 'Label__Text')}>
                                            Vehicle Registration Book <span className="Label__Required">*</span>
                                        </label>
                                        {(vehicleRegistration || formik.values.vehicleRegistrationName) && (
                                            <i
                                                className="pi pi-eye cursor-pointer"
                                                onClick={() => {
                                                    if (isViewMode) {
                                                        showImagePreview(formik.values.vehicleRegistration, 'vehicleRegistration');
                                                    } else if (vehicleRegistration) {
                                                        showImagePreview(vehicleRegistrationPreview, 'vehicleRegistration', true);
                                                    } else if (formik.values.vehicleRegistrationName) {
                                                        showImagePreview(formik.values.vehicleRegistration, 'vehicleRegistration');
                                                    }
                                                }}
                                            ></i>
                                        )}
                                    </div>

                                   <div className="file-input-wrapper">
                                        <InputText
                                            type="file"
                                            accept="image/*,.jpg,.jpeg,.png"
                                            id="vehicleRegistration"
                                            onBlur={formik.handleBlur}
                                            name="vehicleRegistration"
                                            onChange={(e) => {
                                                handleFileChange(e, 'vehicleRegistration');
                                            }}
                                            className={`hidden-file-input ${classNames({ 'p-invalid': isFormFieldValid('vehicleRegistration') })}`}
                                            disabled={isViewMode}
                                        />
                                        <div 
                                            className={`custom-file-input Input__Round ${classNames({ 'p-invalid': isFormFieldValid('vehicleRegistration') })}`}
                                            onClick={() => !isViewMode && document.getElementById('vehicleRegistration').click()}
                                        >
                                            <span className="file-name">
                                                {formik.values.vehicleRegistrationName ? 
                                                    formik.values.vehicleRegistrationName : 
                                                    (vehicleRegistration ? vehicleRegistration.name : "Choose file...")}
                                            </span>
                                            {!isViewMode && <span className="file-button">Browse</span>}
                                        </div>
                                    </div>

                                    {getFormErrorMessage('vehicleRegistration')}
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <div className="flex justify-content-between">
                                        <label htmlFor="fitnessCertificate" className={classNames({ 'p-error': isFormFieldValid('fitnessCertificate') }, 'Label__Text')}>
                                            Fitness Certificate <span className="Label__Required">*</span>
                                        </label>
                                        {(fitnessCertificate || formik.values.fitnessCertificateName) && (
                                            <i
                                                className="pi pi-eye cursor-pointer"
                                                onClick={() => {
                                                    if (isViewMode) {
                                                        showImagePreview(formik.values.fitnessCertificate, 'fitnessCertificate');
                                                    } else if (fitnessCertificate) {
                                                        showImagePreview(fitnessCertificatePreview, 'fitnessCertificate', true);
                                                    } else if (formik.values.fitnessCertificateName) {
                                                        showImagePreview(formik.values.fitnessCertificate, 'fitnessCertificate');
                                                    }
                                                }}
                                            ></i>
                                        )}
                                    </div>
                                   <div className="file-input-wrapper">
                                        <InputText
                                            type="file"
                                            accept="image/*,.jpg,.jpeg,.png"
                                            id="fitnessCertificate"
                                            onBlur={formik.handleBlur}
                                            name="fitnessCertificate"
                                            onChange={(e) => {
                                                handleFileChange(e, 'fitnessCertificate');
                                            }}
                                            className={`hidden-file-input ${classNames({ 'p-invalid': isFormFieldValid('fitnessCertificate') })}`}
                                            disabled={isViewMode}
                                        />
                                        <div 
                                            className={`custom-file-input Input__Round ${classNames({ 'p-invalid': isFormFieldValid('fitnessCertificate') })}`}
                                            onClick={() => !isViewMode && document.getElementById('fitnessCertificate').click()}
                                        >
                                            <span className="file-name">
                                                {formik.values.fitnessCertificateName ? 
                                                    formik.values.fitnessCertificateName : 
                                                    (fitnessCertificate ? fitnessCertificate.name : "Choose file...")}
                                            </span>
                                            {!isViewMode && <span className="file-button">Browse</span>}
                                        </div>
                                    </div>

                                    {getFormErrorMessage('fitnessCertificate')}
                                </div>
                            </div>
                        </div>
                        {/* <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <div className="flex justify-content-between">
                                        <label htmlFor="token" className={classNames({ 'p-error': isFormFieldValid('token') }, 'Label__Text')}>
                                            Token<span className="Label__Required">*</span>
                                        </label>
                                        {(token || formik.values.tokenName) && (
                                            <i
                                                className="pi pi-eye cursor-pointer"
                                                onClick={() => {
                                                    if (isViewMode) {
                                                        showImagePreview(formik.values.token, 'token');
                                                    } else if (token) {
                                                        showImagePreview(tokenPreview, 'token', true);
                                                    } else if (formik.values.tokenName) {
                                                        showImagePreview(formik.values.token, 'token');
                                                    }
                                                }}
                                            ></i>
                                        )}
                                    </div>
                                   <div className="file-input-wrapper">
                                        <InputText
                                            type="file"
                                            accept="image/*,.jpg,.jpeg,.png"
                                            id="token"
                                            onBlur={formik.handleBlur}
                                            name="token"
                                            onChange={(e) => {
                                                handleFileChange(e, 'token');
                                            }}
                                            className={`hidden-file-input ${classNames({ 'p-invalid': isFormFieldValid('token') })}`}
                                            disabled={isViewMode}
                                        />
                                        <div 
                                            className={`custom-file-input Input__Round ${classNames({ 'p-invalid': isFormFieldValid('token') })}`}
                                            onClick={() => !isViewMode && document.getElementById('token').click()}
                                        >
                                            <span className="file-name">
                                                {formik.values.tokenName ? 
                                                    formik.values.tokenName : 
                                                    (token ? token.name : "Choose file...")}
                                            </span>
                                            {!isViewMode && <span className="file-button">Browse</span>}
                                        </div>
                                    </div>

                                    {getFormErrorMessage('token')}
                                </div>
                            </div>
                        </div> */}
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <div className="flex justify-content-between">
                                        <label htmlFor="affidavit" className={classNames({ 'p-error': isFormFieldValid('affidavit') }, 'Label__Text')}>
                                            Affidavit<span className="Label__Required">*</span>
                                        </label>
                                        {(affidavit || formik.values.affidavitName) && (
                                            <i
                                                className="pi pi-eye cursor-pointer"
                                                onClick={() => {
                                                    if (isViewMode) {
                                                        showImagePreview(formik.values.affidavit, 'affidavit');
                                                    } else if (affidavit) {
                                                        showImagePreview(affidavitPreview, 'affidavit', true);
                                                    } else if (formik.values.affidavitName) {
                                                        showImagePreview(formik.values.affidavit, 'affidavit');
                                                    }
                                                }}
                                            ></i>
                                        )}
                                    </div>

                                    <div className="file-input-wrapper">
                                        <InputText
                                            type="file"
                                            accept="image/*,.jpg,.jpeg,.png"
                                            id="affidavit"
                                            onBlur={formik.handleBlur}
                                            name="affidavit"
                                            onChange={(e) => {
                                                handleFileChange(e, 'affidavit');
                                            }}
                                            className={`hidden-file-input ${classNames({ 'p-invalid': isFormFieldValid('affidavit') })}`}
                                            disabled={isViewMode}
                                        />
                                        <div 
                                            className={`custom-file-input Input__Round ${classNames({ 'p-invalid': isFormFieldValid('affidavit') })}`}
                                            onClick={() => !isViewMode && document.getElementById('affidavit').click()}
                                        >
                                            <span className="file-name">
                                                {formik.values.affidavitName ? 
                                                    formik.values.affidavitName : 
                                                    (affidavit ? affidavit.name : "Choose file...")}
                                            </span>
                                            {!isViewMode && <span className="file-button">Browse</span>}
                                        </div>
                                    </div>

                                    {getFormErrorMessage('affidavit')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 className="section-title">Fee Details</h3>
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="paymentMethod" className={classNames({ 'p-error': isFormFieldValid('paymentMethod') }, 'Label__Text')}>
                                        Payment Method<span className="Label__Required">*</span>
                                    </label>
                                    <Dropdown
                                        options={paymentMethods}
                                        optionValue="value"
                                        optionLabel="label"
                                        id="paymentMethod"
                                        placeholder="Please select payment method"
                                        onBlur={formik.handleBlur}
                                        name="paymentMethod"
                                        value={formik.values.paymentMethod || ''}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('paymentMethod') }, 'Dropdown__Round ')}
                                        disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('paymentMethod')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 className="section-title">Fee Details</h3>
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">
                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="permitFee" className={classNames({ 'p-error': isFormFieldValid('permitFee') }, 'Label__Text')}>
                                        Permit Fee<span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        disabled
                                        id="permitFee"
                                        onBlur={formik.handleBlur}
                                        name="permitFee"
                                        value={formik.values.permitFee || ''}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('permitFee') }, 'Input__Round ')}
                                        // disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('permitFee')}
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="permitFine" className={classNames({ 'p-error': isFormFieldValid('permitFine') }, 'Label__Text')}>
                                        Permit Fine<span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        disabled
                                        id="permitFine"
                                        onBlur={formik.handleBlur}
                                        name="permitFine"
                                        value={formik.values.permitFine}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('permitFine') }, 'Input__Round ')}
                                        // disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('permitFine')}
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid grid col-12 md:col-4">
                            <div className="p-field col-12 md:col-12 pt-3">
                                <div className="p-field">
                                    <label htmlFor="totalPermitFee" className={classNames({ 'p-error': isFormFieldValid('totalPermitFee') }, 'Label__Text')}>
                                        Total Amount<span className="Label__Required">*</span>
                                    </label>
                                    <InputText
                                        disabled
                                        id="totalPermitFee"
                                        onBlur={formik.handleBlur}
                                        name="totalPermitFee"
                                        value={Number(formik.values.permitFee || 0) + Number(formik.values.permitFine || 0)}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('totalPermitFee') }, 'Input__Round ')}
                                        // disabled={isViewMode}
                                    />
                                    {getFormErrorMessage('totalPermitFee')}
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isViewMode && (
                        <div className="flex justify-content-center gap-3 mt-4">
                            <Button label="Cancel" type="button" onClick={handleBack} className="p-button-secondary p-button-outlined" style={{ minWidth: '120px', height: '40px' }} />
                            <Button
                                label={isEditing ? 'UPDATE' : 'Submit'}
                                type="submit"
                                loading={formik.isSubmitting}
                                // disabled={isViewMode ? false : !formik.isValid || !isCFXValid}
                                className="p-button-primary"
                                style={{ minWidth: '120px', height: '40px', backgroundColor: '#FF556A', border: 'none' }}
                            />
                        </div>
                    )}

                    {roleName === 'Deputy Director' && isViewMode && (
                        <div className="flex justify-content-center">
                            {(status === 'Rejected' || status === 'Pending') && <Button label={status === 'Rejected' ? 'Rejected' : 'Reject'} className="rej-button" disabled={status !== 'Pending'} onClick={handleUpdateStatus('Rejected')} />}
                            {(status === 'Approved' || status === 'Pending') && <Button label={status === 'Approved' ? 'Approved' : 'Approve'} className="approve-button" disabled={status !== 'Pending'} onClick={handleUpdateStatus('Approved')} />}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}

export default AddEditPermitForm;
